import React from "react";
import PropTypes from "prop-types";
import MediaQuery from "react-responsive";

const Sidebar = ({
  categories,
  hideSidebar,
  isCategoryOpen,
  toggleCategorySidebar
}) => (
  <React.Fragment>
    {/* <div
      className={
        'sidebar ' +
          (categories ? '' : 'blank') +
          (isCategoryOpen ? 'open' : '')
      }
    >
      <MediaQuery query='(max-device-width: 480px)'>
        <div onClick={() => toggleCategorySidebar(false)} className='sidebar__DM'>
          <span>{hideSidebar}</span>
        </div>
      </MediaQuery>
      {categories || null}
    </div> */}
  </React.Fragment>
);
Sidebar.propTypes = {
  categories: PropTypes.shape(),
  hideSidebar: PropTypes.string,
  isCategoryOpen: PropTypes.bool,
  toggleCategorySidebar: PropTypes.func
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/layouts/Sidebar.js